import { blackColors, primaryColor } from 'assets/jss/material-dashboard-pro-react';

const textStyle = {
	marginBottom: 0,
};

const iconStyle = {
	width: '16px',
	height: 'auto',
	maxHeight: '16px',
	color: blackColors[4],
	marginRight: '8px',
};

const cellWithIconStyle = {
	display: 'flex',
	'& svg': {
		...iconStyle,
	},
	'& p': {
		...textStyle,
	},
};

const cellsStyle = (theme) => ({
	phoneNumberCell: {
		alignItems: 'center',
		...cellWithIconStyle,
	},
	cellClick: {
		cursor: 'pointer',
	},
	textCell: ({ maxWidth }) => ({
		width: '100%',
		overflowWrap: ' break-word',
		whiteSpace: 'pre-line',
		'& p': {
			...textStyle,
			lineHeight: theme.direction === 'rtl' ? 1.2 : 'normal',
			maxWidth: maxWidth || 'none',
			overflow: 'hidden',
			textOverflow: maxWidth ? 'ellipsis' : 'clip',
		},
	}),
	departmentsCell: {
		display: 'inline-flex',
		alignItems: 'baseline',
		'& p': {
			...textStyle,
		},
	},
	more: {
		'& p': {
			display: 'inline-flex',
		},
	},
	accountCell: {
		alignItems: 'center',
		height: '100%',
		...cellWithIconStyle,
	},
	iconCell: {
		alignItems: 'center',
		...cellWithIconStyle,
	},
	linkCell: {
		...cellWithIconStyle,
		'& > a': {
			textAlign: 'left',
			alignItems: 'center',
			display: 'inline-flex',
			marginRight: '8px',
			fontFamily: theme.fontFamily.albert.bold,
		},
	},
	disabled: {
		pointerEvents: 'none',
		opacity: 0.5,
	},
	checkboxCell: {
		alignItems: 'center',
	},
	headerCell: {
		marginLeft: 8,
	},
	underline: {
		textDecoration: 'underline',
		textUnderlineOffset: '5px',
		textDecorationColor: primaryColor[0],
	},
});

export default cellsStyle;
